import React, { useState, useEffect } from 'react';
import { buildApiUrl } from '../utils/api';

const NetworkDiagnostic = () => {
  const [diagnostics, setDiagnostics] = useState({
    healthCheck: null,
    corsTest: null,
    environment: null
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    runDiagnostics();
  }, []);

  const runDiagnostics = async () => {
    setLoading(true);
    const results = {
      healthCheck: null,
      corsTest: null,
      environment: {
        apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
        mode: import.meta.env.MODE,
        dev: import.meta.env.DEV,
        prod: import.meta.env.PROD
      }
    };

    // Test health check
    try {
      const healthUrl = buildApiUrl('/health');
      
      const response = await fetch(healthUrl);
      if (response.ok) {
        results.healthCheck = await response.json();
      } else {
        results.healthCheck = { error: `HTTP ${response.status}: ${response.statusText}` };
      }
    } catch (error) {
      results.healthCheck = { error: error.message };
    }

    // Test CORS
    try {
      const corsUrl = buildApiUrl('/cors-test');
      
      const response = await fetch(corsUrl);
      if (response.ok) {
        results.corsTest = await response.json();
      } else {
        results.corsTest = { error: `HTTP ${response.status}: ${response.statusText}` };
      }
    } catch (error) {
      results.corsTest = { error: error.message };
    }

    setDiagnostics(results);
    setLoading(false);
  };

  if (loading) {
    return (
      <div style={{ padding: '20px', border: '1px solid #ccc', margin: '20px', borderRadius: '8px' }}>
        <h3>🔍 Running Network Diagnostics...</h3>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', border: '1px solid #ccc', margin: '20px', borderRadius: '8px', fontFamily: 'monospace' }}>
      <h3>🔍 Network Diagnostics</h3>
      
      <div style={{ marginBottom: '20px' }}>
        <h4>Environment:</h4>
        <pre style={{ background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
          {JSON.stringify(diagnostics.environment, null, 2)}
        </pre>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h4>Health Check:</h4>
        <pre style={{ 
          background: diagnostics.healthCheck?.error ? '#ffebee' : '#e8f5e8', 
          padding: '10px', 
          borderRadius: '4px',
          color: diagnostics.healthCheck?.error ? '#c62828' : '#2e7d32'
        }}>
          {JSON.stringify(diagnostics.healthCheck, null, 2)}
        </pre>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h4>CORS Test:</h4>
        <pre style={{ 
          background: diagnostics.corsTest?.error ? '#ffebee' : '#e8f5e8', 
          padding: '10px', 
          borderRadius: '4px',
          color: diagnostics.corsTest?.error ? '#c62828' : '#2e7d32'
        }}>
          {JSON.stringify(diagnostics.corsTest, null, 2)}
        </pre>
      </div>

      <button 
        onClick={runDiagnostics}
        style={{
          padding: '10px 20px',
          background: '#8B4513',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        🔄 Run Diagnostics Again
      </button>
    </div>
  );
};

export default NetworkDiagnostic;